var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('PedidosList',{attrs:{"resultado":""}})],1),_c('v-col',[_c('ReviewModelsList',{attrs:{"manual":false}}),_c('ReviewModelsList',{attrs:{"manual":true}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }